export default __webpack_public_path__ + "static/upper3_1-2216d6d22e1198957e43a7e90e8ebdce.jpg";